import { Text, View, Image, Svg, Path, Rect } from '@react-pdf/renderer';

import { dateFormat } from '../../../../../lib/format/format';

export const PdfPrimaryOfficerInformation = (account, styles) => {
  const {
    grdRow,
    grdCell,
    grdHeader,
    grdSubHeader,
    BB,
    BL,
    BR,
    label,
    text,
    mT20,
    nM,
    nP,
  } = styles;

  const CheckBox = () => (
    <Svg style={{ width: 15, height: 15 }} viewBox="0 0 130 130" fill="none">
      <Rect style={{ width: 15, height: 15 }} rx="10" />
      <Rect
        width="130"
        height="130"
        fill="white"
        stroke="#373737"
        stroke-width="24"
        mask="url(#path-1-inside-1)"
      />
      <Rect transform="translate(29 29)" fill="white" />
      <Path
        d="M82.6435 48.6296L58.2104 73.0954L48.3543 63.2078L48.3476 63.2011L48.3408 63.1945C47.9206 62.7886 47.4245 62.4694 46.881 62.2552C46.3374 62.041 45.757 61.936 45.1728 61.9461C44.5886 61.9562 44.0122 62.0812 43.4764 62.3141C42.9405 62.547 42.4558 62.8832 42.0499 63.3034C41.644 63.7236 41.3248 64.2196 41.1106 64.7632C40.8964 65.3068 40.7913 65.8872 40.8014 66.4714C40.8116 67.0555 40.9366 67.632 41.1695 68.1678C41.4012 68.7008 41.735 69.1833 42.1522 69.5879L55.1035 82.5392C55.1041 82.5398 55.1047 82.5404 55.1053 82.541C55.5116 82.9502 55.9949 83.2751 56.5272 83.4969C57.0604 83.719 57.6322 83.8333 58.2098 83.8333C58.7873 83.8333 59.3592 83.719 59.8923 83.4969C60.4247 83.2751 60.9079 82.9502 61.3143 82.541C61.3149 82.5404 61.3154 82.5398 61.316 82.5392L88.8398 55.0154C89.2765 54.6085 89.6255 54.1166 89.865 53.5697C90.1074 53.0162 90.2325 52.4186 90.2325 51.8144C90.2325 51.2102 90.1074 50.6125 89.865 50.0591C89.6255 49.5125 89.2768 49.0206 88.8404 48.6139C88.4369 48.2112 87.9586 47.8912 87.4323 47.6719C86.8992 47.4498 86.3273 47.3354 85.7498 47.3354C85.1722 47.3354 84.6004 47.4498 84.0672 47.6719C83.5347 47.8938 83.0513 48.2188 82.6449 48.6282C82.6444 48.6286 82.644 48.6291 82.6435 48.6296Z"
        fill="#292929"
        stroke="black"
        stroke-width="6"
      />
    </Svg>
  );

  const isSameCountry = (country) => {
    if (account.primaryOwner.country === country || !country) {
      return true;
    }
    return false;
  };

  return (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <Text>
          Primary{' '}
          {account.primaryOwner.isOfficer && account.primaryOwner.isOwner
            ? 'Officer/Owner'
            : account.primaryOwner.isOwner
            ? 'Owner'
            : 'Officer'}{' '}
          Information
        </Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>First Name:</Text>
          <Text style={[text]}>{account.primaryOwner.firstName}</Text>
        </View>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>Middle Name:</Text>
          <Text style={[text]}>{account.primaryOwner.middleName}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
          <Text style={label}>Last Name:</Text>
          <Text style={[text]}>{account.primaryOwner.lastName}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>Phone Number:</Text>
          <Text style={[text]}>{account.primaryOwner.phone}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
          <Text style={label}>Type:</Text>
          <Text style={[text]}>
            {account.primaryOwner.isOfficer ? 'Officer' : ''}
            {account.primaryOwner.isOfficer && account.primaryOwner.isOwner ? ', ' : ''}
            {account.primaryOwner.isOwner ? 'Owner' : ''}
          </Text>
        </View>
        {account.primaryOwner.isOwner && (
          <View style={[grdCell, BB, BR, { width: 33.33 }]}>
            <Text style={label}>Ownership Percentage:</Text>
            <Text style={[text]}>{account.primaryOwner.ownershipPercent} %</Text>
          </View>
        )}
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 50 }]}>
          <Text style={label}>Address:</Text>
          <Text style={[text]}>
            {account.primaryOwner.address1} {account.primaryOwner.address2}
          </Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
          <Text style={label}>City:</Text>
          <Text style={[text]}>{account.primaryOwner.city}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BL, { width: 33.33 }]}>
          <Text style={label}>State:</Text>
          <Text style={[text]}>{account.primaryOwner.state}</Text>
        </View>
        <View style={[grdCell, BL, { width: 33.33 }]}>
          <Text style={label}>Zip Code:</Text>
          <Text style={[text]}>{account.primaryOwner.zip}</Text>
        </View>
        <View style={[grdCell, BL, BR, { width: 33.33 }]}>
          <Text style={label}>Country:</Text>
          <Text style={[text]}>{account.primaryOwner.country}</Text>
        </View>
      </View>
      <View style={[grdHeader]}>
        <Text>Identification</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL]}>
          <Text style={label}>Identification Type:</Text>
          <Text style={[text]}>
            {account.primaryOwner.identification.identificationType}
          </Text>
        </View>
        <View style={[grdCell, BB, BL]}>
          <Text style={label}>Identification No.:</Text>
          <Text style={[text]}>
            {account.primaryOwner.identification.identificationNo}
          </Text>
        </View>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Issue Date:</Text>
          <Text style={[text]}>
            {dateFormat(account.primaryOwner.identification.issueDate)}
          </Text>
        </View>
        <View style={[grdCell, BB, BR]}>
          <Text style={label}>Expiration Date:</Text>
          <Text style={[text]}>
            {dateFormat(account.primaryOwner.identification.expirationDate)}
          </Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BL, { width: 50 }]}>
          <Text style={label}>Birth Date:</Text>
          <Text style={[text]}>
            {dateFormat(account.primaryOwner.identification.dateOfBirth)}
          </Text>
        </View>
        <View style={[grdCell, BL, BR, { width: 50 }]}>
          <Text style={label}>
            {account.primaryOwner.identification.taxCountry === 'US'
              ? 'Social Security No:'
              : 'Foreign Tax ID:'}
          </Text>
          <Text style={[text]}>{account.primaryOwner.identification.taxNo}</Text>
        </View>
      </View>
      <View style={[grdSubHeader]}>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, nP, { width: 250 }]}>
            <Text></Text>
          </View>
          <View style={[grdCell, nP, { width: 50, textAlign: 'center' }]}>
            <Text>Yes</Text>
          </View>
          <View style={[grdCell, nP, { width: 50, textAlign: 'center' }]}>
            <Text>No</Text>
          </View>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>My country of ID is the same as my physical address.</Text>
          {!isSameCountry(account.primaryOwner.identification.countryOfIssuance) && (
            <View style={[grdRow, nM, mT20]}>
              <Text style={[label]}>Country of Issuance: </Text>
              <Text style={[text]}>
                {account.primaryOwner.identification.countryOfIssuance}
              </Text>
            </View>
          )}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {isSameCountry(account.primaryOwner.identification.countryOfIssuance) && (
            <CheckBox />
          )}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {!isSameCountry(account.primaryOwner.identification.countryOfIssuance) && (
            <CheckBox />
          )}
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>My country of taxation is the same as my physical address.</Text>
          {!isSameCountry(account.primaryOwner.identification.taxCountry) && (
            <View style={[grdRow, nM, mT20]}>
              <Text style={[label]}>Tax Country: </Text>
              <Text style={[text]}>{account.primaryOwner.identification.taxCountry}</Text>
            </View>
          )}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {isSameCountry(account.primaryOwner.identification.taxCountry) && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {!isSameCountry(account.primaryOwner.identification.taxCountry) && <CheckBox />}
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>My country of citizenship is the same as my physical address.</Text>
          {!isSameCountry(account.primaryOwner.identification.citizenship) && (
            <View style={[grdRow, nM, mT20]}>
              <Text style={[label]}>Citizenship: </Text>
              <Text style={[text]}>
                {account.primaryOwner.identification.citizenship}
              </Text>
            </View>
          )}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {isSameCountry(account.primaryOwner.identification.citizenship) && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {!isSameCountry(account.primaryOwner.identification.citizenship) && (
            <CheckBox />
          )}
        </View>
      </View>
      <View style={[grdSubHeader, { textAlign: 'center' }]}>
        <Text>Proof of Identity:</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          {account.primaryOwner.identification.imgGovernmentId ? (
            <Image
              style={styles.imageThumbnail}
              src={{
                uri: account.primaryOwner.identification.imgGovernmentId,
                method: 'GET',
              }}
            />
          ) : (
            <Text style={[{ textAlign: 'center' }]}>No proof of identity provided.</Text>
          )}
        </View>
      </View>
    </View>
  );
};
